import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeSpecialChar',
  standalone: true
})
export class DecodeSpecialCharPipe implements PipeTransform {
  private parser = new DOMParser();

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const doc = this.parser.parseFromString(value, 'text/html');
    return doc.documentElement.textContent || '';
  }
}